import { Feature, Point } from "geojson";
import { Coordinates } from "../../core/types";

export function pointRadius(
  x: number,
  y: number,
  r: number
): [Coordinates, Coordinates] {
  return [
    [x - r, y - r],
    [x + r, y + r],
  ];
}

export function sortClosest(x: number, y: number) {
  return (a: Feature<Point>, b: Feature<Point>) =>
    squareDiff(a.geometry.coordinates as Coordinates, [x, y]) -
    squareDiff(b.geometry.coordinates as Coordinates, [x, y]);
}

function squareDiff(a: Coordinates, b: Coordinates): number {
  return Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2);
}

export function coordinatesToBounds(
  coordsArr: Array<Coordinates>
): [Coordinates, Coordinates] | null {
  return coordsArr.reduce(
    (
      acc: [Coordinates, Coordinates] | null,
      coords
    ): [Coordinates, Coordinates] =>
      acc == null
        ? [coords, coords]
        : ([
            acc[0].map((n, i) => Math.min(n, coords[i])),
            acc[1].map((n, i) => Math.max(n, coords[i])),
          ] as [Coordinates, Coordinates]),
    null
  );
}
